import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
    selectedCustomSourcesBusinessTotal: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedCustomSourcesBusinessTotal(state, payload) {
      state.selectedCustomSourcesBusinessTotal = payload
    }
  },
  actions: {
    async loadBySourceID({ commit }, id) {
      commit("setListLoading", true);
      let result = await api.get('customSourcesBusinessTotal/bySourceID', { params: { id: id } })
      if (result.data.length > 0) {
        commit('setSelectedCustomSourcesBusinessTotal', result.data[0]);
      } else {
        commit('setSelectedCustomSourcesBusinessTotal', null);
      }
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("/customSourcesBusinessTotal", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {}
      await api.put('/customSourcesBusinessTotal', payload).then(response => {

        if (response.data.Result == 'Success') {
          returnData = {
            Result: "Success",
            Response: response.data
          };
        } else {
          returnData = {
            Result: "Failed",
            Response: response.data
          };
        }
      }).catch(err => {
        returnData = {
          Result: "Error",
          Response: {
            Message: "There was an Error, Please try again later"
          }
        }
      })
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedCustomSourcesBusinessTotal(state) {
      return state.selectedCustomSourcesBusinessTotal
    }
  }
}
